export enum FaceRouteName {
  agreement = 'face-auth-agreement',
  result = 'face-auth-result'
}

export enum FaceAuthType {
  /**
   * @description: 登录
   */
  LOGIN = 'login',
  /**
   * @description: 提现
   */
  WITHDRAW = 'withdraw',
  /**
   * @description: 实名认证
   */
  AUTH = 'auth'
}
